import { useSelector, useDispatch } from 'react-redux';
import CollapsibleSection from './CollapsibleSection';
import G from './Getters';
import { useDrag, useDrop, useDragLayer } from 'react-dnd';

import VerticalResizable from './VerticalResizable';

import LooseData from './LooseData';
import Id from './IdFactory';

import { useState } from 'react';



import ChannelTable from './ChannelTable';
//import ImageSetTypeContainer from './ImageSetTypeContainer';

const directoryTypeOptions = ["microscopy"].map(x => <option>{x}</option>);


export default function DirectoryContentView({
  processExecutionId
}){


  

  const dispatch = useDispatch();

  const [ looseItemsSelected, setLooseItemsSelected ] = useState([]);


  const [ measurementId, setMesurementId ] = useState("DEFAULT_MEASUREMENT");

  let { data, meta } = useSelector(state => G.getRecord(state,{_id:processExecutionId}));
  let name = meta.filesystemName

  let { children=[] } = data;
  




  function onGroup(e){

    debugger;
    // link everything into a group

    let newImageSetId = Id();
    dispatch({
      type:"moveImagesToImageSet",
      imageIds:looseItemsSelected,
      destinationImageSetId:newImageSetId,
    });


    let channelKeys = Object.keys(data.measurements[measurementId].config.channels);

    let other = looseItemsSelected.slice(channelKeys.length);

    let channelGroup = Object.fromEntries(channelKeys.map((channelId,ii) => {
      return [channelId,looseItemsSelected[ii]]
    }))

    

    dispatch({
      type:"linkDataToExecutionResults",
      executionId:processExecutionId,
      measurementId,
      linkArgsList:[{
        item:{ _id:newImageSetId, type:"imageSets" },
        args:{ channelGroup }
      }]
    })
  }

  
  return (
    <div style={{
      //border:'3px solid orange', 
      minHeight:0
    }} class="flex-expand sg-col">

      <div class="sg-col flex-expand" style={{
        //border:'3px solid red',
        minHeight:0,
      }}>
        <h5 style={{textAlign:'center'}}>Experiment Images by Channel</h5>
        <div class="rel flex-expand" style={{
          minHeight:0,
          //border:'3px solid green',
          overflow:'scroll',
        }}>
          <ChannelTable processExecutionId={processExecutionId} execution={data} measurementId={measurementId}/>
        </div>
      </div>


      <VerticalResizable>



        <LooseData {...{
          setLooseItemsSelected,
          looseItemsSelected,
          processExecutionId,
          onGroup
        }}/>


      </VerticalResizable>



    </div>
  )
}


